import React, { useState, useEffect } from "react";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import Hardware from "./Hardware";
import EliminarBajas from "./EliminarBajas";
import ModificarBajas from "./ModificarBajas";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function ConsultarBajas() {
    const { permisos, logout } = useGlobal();
    const [bajas, setBajas] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const [seleccionado, setSeleccionado] = useState(null);
    const [mostrarHardware, setMostrarHardware] = useState(false);
    const [modoEliminar, setModoEliminar] = useState(false);
    const [modoModificar, setModoModificar] = useState(false);
    const apiFetch = useApiFetch();
    const tienePermisoConsultar = permisos.includes(22); // id_permiso=22 "Consultar Bajas"

    useEffect(() => {
        if (tienePermisoConsultar) {
            const cargarBajas = async () => {
                const data = await apiFetch("consultar_bajas.php", {
                    method: "GET"
                }, logout);

                if (data.status === "ok") {
                    setBajas(data.bajas || []);
                } else {
                    setMensaje(data.message || "No se pudieron cargar las bajas.");
                    setTimeout(() => setMostrarHardware(true), 3000);
                }
            };

            cargarBajas().catch(() => setMensaje("Error al cargar bajas."));
        }
    }, [tienePermisoConsultar]);

    if (!tienePermisoConsultar) {
        return <p>Acceso denegado. No tiene permiso para consultar bajas.</p>;
    }

    if (mostrarHardware) {
        return <Hardware />;
    }

    // Exportar en CSV
    const handleExportar = () => {
        let datosExportar = [];

        if (seleccionado) {
            // Exportar solo el registro seleccionado
            const bajaSel = bajas.find(b => b.id_baja === seleccionado);
            if (bajaSel) {
                datosExportar = [bajaSel];
            }
        } else {
            // Exportar todos los registros
            datosExportar = bajas;
        }

        if (datosExportar.length === 0) {
            alert("No hay datos para exportar.");
            return;
        }

        // Construir CSV
        const encabezados = ["id_baja", "baja", "total_dictamenes", "total_bienes"];
        const filas = datosExportar.map(b => [
            b.id_baja,
            b.baja,
            b.total_dictamenes,
            b.total_bienes
        ]);

        const csvContent = [
            encabezados.join(","), // primera fila: encabezados
            ...filas.map(fila => fila.join(","))
        ].join("\n");

        // Crear archivo y disparar descarga
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "bajas.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Exportar en PDF
    const handleExportarPDF = () => {
        let datosExportar = [];

        if (seleccionado) {
            const bajaSel = bajas.find(b => b.id_baja === seleccionado);
            if (bajaSel) {
                datosExportar = [bajaSel];
            }
        } else {
            datosExportar = bajas;
        }

        if (datosExportar.length === 0) {
            alert("No hay datos para exportar.");
            return;
        }

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de Bajas", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["ID Baja", "Baja", "Total Dictámenes", "Total Bienes"]],
            body: datosExportar.map(b => [
                b.id_baja,
                b.baja,
                b.total_dictamenes,
                b.total_bienes
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_bajas.pdf");
    };

    const handleEliminar = () => {
        if (seleccionado) {
            setModoEliminar(true);
        }
    };

    const handleModificar = () => {
        if (seleccionado) {
            setModoModificar(true);
        }
    };

    if (modoEliminar) {
        const bajaSel = bajas.find(b => b.id_baja === seleccionado);
        if (!bajaSel) {
            return <p>Error: no se encontró la baja seleccionada.</p>;
        }
        return (
            <EliminarBajas
                idBajaInicial={bajaSel.id_baja}
                bajaInicial={bajaSel.baja}
                totalDictamenesInicial={bajaSel.total_dictamenes}
                totalBienesInicial={bajaSel.total_bienes}
            />
        );
    }

    if (modoModificar) {
        const bajaSel = bajas.find(b => b.id_baja === seleccionado);
        if (!bajaSel) {
            return <p>Error: no se encontró la baja seleccionada.</p>;
        }
        return (
            <ModificarBajas
                idBajaInicial={bajaSel.id_baja}
                bajaInicial={bajaSel.baja}
                totalDictamenesInicial={bajaSel.total_dictamenes}
                totalBienesInicial={bajaSel.total_bienes}
            />
        );
    }

    return (
        <div className="sesion-form">
            <h2>Lista de Bajas</h2>
            {mensaje && <p className="error">{mensaje}</p>}

            <table className="tabla-estandar seleccion-unica">
                <thead>
                    <tr>
                        <th>Seleccionar</th>
                        <th>Baja</th>
                        <th>Total Dictámenes</th>
                        <th>Total Bienes</th>
                    </tr>
                </thead>
                <tbody>
                    {bajas.map((baja) => (
                        <tr key={baja.id_baja}>
                            <td data-label="Seleccionar">
                                <input
                                    type="checkbox"
                                    checked={seleccionado === baja.id_baja}
                                    onChange={() => {
                                        const nuevo = seleccionado === baja.id_baja ? null : baja.id_baja;
                                        setSeleccionado(nuevo);
                                        console.log("Seleccionado:", nuevo);
                                    }}
                                />
                            </td>
                            <td data-label="Baja">{baja.baja}</td>
                            <td data-label="Total de dictámenes">{baja.total_dictamenes}</td>
                            <td data-label="Total de bienes">{baja.total_bienes}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="form-buttons">
                <button disabled={!seleccionado} onClick={handleModificar}>Modificar</button>
                <button disabled={!seleccionado} onClick={handleEliminar}>Eliminar</button>
                <button className="exportar" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                <button className="exportar" onClick={handleExportarPDF}>Exportar<br></br>en PDF</button>
            </div>
        </div>
    );
}

export default ConsultarBajas;